import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { path, mergeDeepLeft, clone } from 'ramda';
import Input from '../../common/Input';
import InputMask from '../../common/InputMask';
import CheckBox from '../../common/CheckBox';
import Select from '../../common/Select';
import DatePicker from '../../common/DatePicker';
import DynamicFormGridList from '../../common/DynamicFormGridList';
import Currency from '../../common/Currency';
import Breadcrumbs from '../../common/Breadcrumbs';
import '../../css/forms/default-forms.css';
import fields from './fields/fields';
import vacations from './fields/vacations';
import working_terms from './fields/working_terms';
import emergency_contacts from './fields/emergency_contacts';
import bonuses from './fields/bonuses';
import past_raises from './fields/past_raises';
import insurance_plans from './fields/insurance_plans';
import disciplinary_actions from './fields/disciplinary_actions';
import statuses from './fields/statuses';
import { validateFields, validateField } from '../../utils/validate';
import { processFields } from '../../utils/prePost';
import { fetchCountries, fetchStates } from '../../api/geo';
import { fetchEmployee, addEmployee, updateEmployee, getEmployeePdf } from '../../api/employees';
import { setServerErrors, removeFieldName } from '../../utils/server_error_rule';
import moment from 'moment';
import { addNotification as notify } from 'reapop';
import { linkDataToFields } from '../../utils/fields';
import SimpleDatePicker from "../../common/SimpleDatePicker";

export class ManageEmployeeItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            submit: false,
            errors: [],
            fields: clone(fields),
            showPrevVacations: false
        };

        this.submit = this.submit.bind(this);
        this.cancel = this.cancel.bind(this);
        this.changeFormValue = this.changeFormValue.bind(this);
        this.onFormatValue = this.onFormatValue.bind(this);
        this.getStates = this.getStates.bind(this);
        this.validateFields = this.validateFields.bind(this);
        this.setFieldsFromData = this.setFieldsFromData.bind(this);
        this.attachFile = this.attachFile.bind(this);
        this.donwloadPdfPreview = this.donwloadPdfPreview.bind(this);
        this.renderTenureInput = this.renderTenureInput.bind(this);
        this.onTenureCalc = this.onTenureCalc.bind(this);
        this.onVacationsRender = this.onVacationsRender.bind(this);
        this.togglePreviousVacations = this.togglePreviousVacations.bind(this);
        this.onRenderVacationItem = this.onRenderVacationItem.bind(this);
        this.logs = this.logs.bind(this);
    }

    componentWillMount() {
        this.props.getCountries();
        const id = path(['match', 'params', 'id'], this.props);
        if (!id && this.state.fields['country_id'].value) {
            this.props.getStates(this.state.fields['country_id'].value);
        }
    }

    componentDidMount() {
        const id = path(['match', 'params', 'id'], this.props);
        if (id) {
            this.props.getEmployee(id);
        }
    }

    componentWillReceiveProps(nextProps) {
        this.validateFields(nextProps);
        this.setFieldsFromData(nextProps);
    }

    validateFields(nextProps) {
        const prevErrors = path(['employees', 'errors'], this.props);
        const errors = path(['employees', 'errors'], nextProps);

        if ((errors || prevErrors) && prevErrors !== errors) {
            const fields = setServerErrors(this.state.fields, errors, removeFieldName);
            validateFields(fields);
        }
    }

    setFieldsFromData(nextProps) {
        const prevEmployee = path(['employees', 'currentEmployee'], this.props);
        const employee = path(['employees', 'currentEmployee'], nextProps);

        if (prevEmployee !== employee) {
            const extraFields = {
                vacations: vacations,
                working_terms: working_terms,
                emergency_contacts: emergency_contacts,
                bonuses: bonuses,
                insurance_plans: insurance_plans,
                past_raises: past_raises,
                disciplinary_actions: disciplinary_actions
            };

            const fixDate = (currentItem, dataForMutate) =>
                currentItem.dateFormat && dataForMutate === '0000-00-00' ? '' : dataForMutate;

            const dataForMutate = {
                birthdate: fixDate,
                original_hire_date: fixDate,
                hire_date: fixDate,
                last_worked_date: fixDate,
                last_check_date: fixDate,
                rehire_eligibility_date: fixDate,
                date: fixDate,
                date_from: fixDate,
                date_to: fixDate
            };

            const fields = linkDataToFields(employee, this.state.fields, dataForMutate, extraFields);

            if (fields['country_id'] && fields['country_id'].value && fields['country_id'].value > 0) {
                this.props.getStates(fields['country_id'].value);
            }

            if (fields['state_id'] && (!fields['state_id'].value || fields['state_id'].value == 0)) {
                fields['state_id'].value = '';
            }

            this.setState(fields);
        }
    }

    setVacationFields(fields) {
        const now = moment(moment.now()).utc(false);
        const workingDays = fields['vacations']
            .filter(x => x.date_from.value && x.date_to.value && x.number_of_working_days.value > 0)
            .map(x => ({
                'from': moment(x.date_from.value),
                'to': moment(x.date_to.value),
                'cnt': parseInt(x.number_of_working_days.value)
            }))
            .filter(x => x.cnt > 0 && x.to.year() === now.year())
            .map(x => x.cnt);

        let vacationUsed = 0;
        if (workingDays.length > 0) {
            vacationUsed = workingDays.reduce((a, b) => a + b);
            if (vacationUsed < 0) {
                vacationUsed = 0;
            }
        }
        fields['vacation_used'].value = vacationUsed.toString();
        fields['vacation_available'].value = (parseInt(fields['vacation_limit'].value) - vacationUsed).toString();
    }

    changeFormValue(field, newObject) {
        let stateClone = clone(this.state);
        stateClone.fields[field] = newObject;

        if (field === 'country_id') {
            stateClone.fields['state_id'].value = '';
            this.props.getStates(newObject.value);
        } else if (field === 'tenure') {
            const tenure = parseInt(newObject.value);
            stateClone.fields['vacation_limit'].value = (tenure < 0 ? 0
                : tenure < 365 ? 10
                    : tenure < 1000 ? 15
                        : 17).toString();
            this.setVacationFields(stateClone.fields);
        } else if ((field.length === 2 && field[0] === 'vacations') || field === 'vacation_limit') {
            this.setVacationFields(stateClone.fields);
        } else if (field === 'vacations') {
            this.setVacationFields(stateClone.fields);
        }
        this.setState(mergeDeepLeft(stateClone, this.state));
    }

    logs() {
        const id = path(['match', 'params', 'id'], this.props);

        this.props.goToLogs(id);
    }


    submit(e) {
        e.preventDefault();
        setServerErrors(this.state.fields, {});
        let ss_no = this.state.fields["ss_no"].value;
        if (ss_no) {
            this.state.fields["ss_no"].value = ss_no.toString().replace(/\D/g, '');
        }
        let result = validateFields(this.state.fields);
        if (result.check === false) {
            this.setState({
                fields: result.fields,
            });
            const id = path(['match', 'params', 'id'], this.props);
            this.props.notifyValidationFailed(id);
        } else {
            const processedData = processFields(this.state.fields, this.onFormatValue);
            this.ensureArray(processedData, 'vacations');
            this.ensureArray(processedData, 'working_terms');
            this.ensureArray(processedData, 'emergency_contacts');
            this.ensureArray(processedData, 'bonuses');
            this.ensureArray(processedData, 'insurance_plans');
            this.ensureArray(processedData, 'past_raises');
            this.ensureArray(processedData, 'disciplinary_actions');
            const id = path(['match', 'params', 'id'], this.props);
            this.props.saveForm(id, processedData)
        }
        return false;
    }

    onFormatValue(field) {
        if (field.dateFormat) {
            if (!field.value) {
                return '';
            }

            try {
              return  moment.tz(field.value, moment.tz.guess()).format('YYYY-MM-DD');
            } catch (e) {
                console.log(e);
            }
        }

        return field.value;
    }

    ensureArray(obj, name) {
        if (!obj[name]) {
            obj[name] = [];
        }
    }

    cancel() {
        this.props.goToEmployees();
    }

    getStates() {
        const countryId = this.state.fields.countryId;
        return countryId ? this.props.getStates(countryId) : [];
    }

    parseGeoList(arr) {
        const res = [];

        if (arr) {
            for (let i = 0; i < arr.length; i++) {
                res.push({
                    value: arr[i].id,
                    text: arr[i].name,
                });
            }
        }

        return res;
    }

    attachFile() {
        const id = path(['match', 'params', 'id'], this.props);
        this.props.goToAttachments(id);
    }

    donwloadPdfPreview() {
        const id = path(['match', 'params', 'id'], this.props);
        this.props.getPdf(id);
    }


    render() {
        const fields = this.state.fields;

        const hasId = path(['match', 'params', 'id'], this.props);
        const countries = this.parseGeoList(path(['geo', 'countries'], this.props)) || [];
        const states = fields['country_id'] && fields['country_id'].value > 0 ? this.parseGeoList(path(['geo', 'states'], this.props)) || [] : [];

        const breadcrumbs = [
            { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
            { url: '/pages/employees', icon: 'people', name: 'Employees' }
        ];

        if (hasId) {
            breadcrumbs.push({ icon: 'edit', name: 'Edit Employee' });
        } else {
            breadcrumbs.push({ icon: 'person_add', name: 'Add Employee' });
        }

        return (
            <div className="row">
                <div className="col">
                    <Breadcrumbs list={breadcrumbs} />
                    <div className="card rounded">
                        <div className="card-header rounded-top">
                            {hasId ? 'Edit Employee' : 'Add Employee'}
                        </div>
                        <div className="card-block">
                            <div className="col-12" style={{ paddingBottom: '40px' }}>
                                <button
                                    className={'btn btn-danger btn-outline float-right'}
                                    onClick={this.cancel}
                                >
                                    <i className="fa fa-remove"></i>
                                    <span style={{ paddingLeft: '3px' }}>Cancel</span>
                                </button>
                                <button className={'btn btn-success btn-outline float-right'} onClick={this.submit} style={{ marginRight: '10px' }}>
                                    <i className="fa fa-check"></i>
                                    <span style={{ paddingLeft: '3px' }}>Save & Continue</span>
                                </button>
                                {hasId && (<button className={'btn btn-default btn-outline float-right'} onClick={this.attachFile} style={{ marginRight: '10px' }}>
                                    <i className="fa fa-file"></i>
                                    <span style={{ paddingLeft: '3px' }}>Attach File</span>
                                </button>)}
                                {hasId && (<button type="button" className={'btn btn-default btn-outline float-right'} onClick={this.logs} style={{ marginRight: '10px' }}>
                                    <i className="fa fa-info-circle"></i>
                                    <span style={{ paddingLeft: '3px' }}>Logs</span>
                                </button>)}
                                {hasId && (<button className={'btn btn-default btn-outline float-right'} onClick={this.donwloadPdfPreview} style={{ marginRight: '10px' }}>
                                    <i className="fa fa-file-pdf-o"></i>
                                    <span style={{ paddingLeft: '3px' }}>Print Preview</span>
                                </button>)}
                            </div>
                            <form onSubmit={this.submit}>
                                <div className="row">
                                    <div className="col col-12">
                                        <InputMask
                                            field={fields['ss_no']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col col-6">
                                        <Input
                                            field={fields['firstname']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                    <div className="col col-6">
                                        <Input
                                            field={fields['lastname']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col col-6">
                                        <Input
                                            field={fields['department']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                    <div className="col col-6">
                                        <Input
                                            field={fields['job_title']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col col-12">
                                        <Select
                                            options={statuses}
                                            field={fields['status']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col col-6">
                                        <Input
                                            field={fields['cell_phone']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                    <div className="col col-6">
                                        <Input
                                            field={fields['work_phone']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col col-12">
                                        <SimpleDatePicker
                                            field={fields['birthdate']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col col-12">
                                        <b>Employee Address</b>
                                        <div style={{ 'paddingLeft': '30px', 'paddingTop': '20px' }}>
                                            <Input
                                                field={fields['address1']}
                                                onChange={this.changeFormValue}
                                            />
                                            <Input
                                                field={fields['city']}
                                                onChange={this.changeFormValue}
                                            />
                                            <Select
                                                options={states}
                                                field={fields['state_id']}
                                                onChange={this.changeFormValue}
                                            />
                                            <Input
                                                field={fields['zip']}
                                                onChange={this.changeFormValue}
                                            />
                                            <Select
                                                options={countries}
                                                field={fields['country_id']}
                                                onChange={this.changeFormValue}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col col-6">
                                        <SimpleDatePicker
                                            field={fields['original_hire_date']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                    <div className="col col-6">
                                        <Input
                                            field={fields['tenure']}
                                            onChange={this.changeFormValue}
                                            onRender={this.renderTenureInput}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col col-6">
                                        <SimpleDatePicker
                                            field={fields['last_worked_date']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                    <div className="col col-6">
                                        <SimpleDatePicker
                                            field={fields['last_check_date']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col col-12">
                                        <Input
                                            field={fields['termination_reason']}
                                            onChange={this.changeFormValue}
                                        />
                                        <CheckBox
                                            field={fields['rehire_eligibility']}
                                            onChange={this.changeFormValue}
                                        />
                                        <SimpleDatePicker
                                            field={fields['rehire_eligibility_date']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col col-12">
                                        <DynamicFormGridList
                                            list={fields['working_terms']}
                                            fields={working_terms}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col col-4">
                                        <Input
                                            field={fields['vacation_limit']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                    <div className="col col-4">
                                        <Input
                                            field={fields['vacation_used']}
                                            onChange={this.changeFormValue}
                                            disabled={true}
                                        />
                                    </div>
                                    <div className="col col-4">
                                        <Input
                                            field={fields['vacation_available']}
                                            onChange={this.changeFormValue}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col col-12">
                                        <DynamicFormGridList
                                            list={fields['vacations']}
                                            fields={vacations}
                                            onChange={this.changeFormValue}
                                            addToStart={true}
                                            onRender={this.onVacationsRender}
                                            onRenderListItem={this.onRenderVacationItem}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col col-4">
                                        <Currency
                                            field={fields['start_rate']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                    <div className="col col-4">
                                        <Currency
                                            field={fields['earnings_rate']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                    <div className="col col-4">
                                        <Currency
                                            field={fields['last_earnings_rate']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col col-4">
                                        <Currency
                                            field={fields['start_salary']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                    <div className="col col-4">
                                        <Currency
                                            field={fields['previous_salary']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                    <div className="col col-4">
                                        <Currency
                                            field={fields['current_salary']}
                                            onChange={this.changeFormValue}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col col-12">
                                        <DynamicFormGridList
                                            list={fields['bonuses']}
                                            onChange={this.changeFormValue}
                                            fields={bonuses}
                                            addToStart={true}
                                        />
                                        <DynamicFormGridList
                                            list={fields['past_raises']}
                                            onChange={this.changeFormValue}
                                            fields={past_raises}
                                            addToStart={true}
                                        />
                                        <DynamicFormGridList
                                            list={fields['insurance_plans']}
                                            onChange={this.changeFormValue}
                                            fields={insurance_plans}
                                        />
                                        <DynamicFormGridList
                                            list={fields['disciplinary_actions']}
                                            onChange={this.changeFormValue}
                                            fields={disciplinary_actions}
                                            addToStart={true}
                                        />
                                        <DynamicFormGridList
                                            list={fields['emergency_contacts']}
                                            onChange={this.changeFormValue}
                                            fields={emergency_contacts}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderTenureInput(ctx) {
        const { type, elem } = ctx;
        if (type === 'input' && elem) {
            return (<div>
                {elem}
                <button type="button" className="btn btn-success btn-outline" style={{ 'float': 'right', 'margin': '10px 0' }} onClick={this.onTenureCalc}>Calculate</button>
            </div>);
        }
        return elem
    }

    onTenureCalc() {
        const { fields } = this.state;
        const tenure = fields.tenure;

        validateField(fields.working_terms);
        const days = !fields.working_terms || fields.working_terms.length === 0 ? null : fields.working_terms
            .filter(x => x.date_from)
            .sort(x => x.date_from)
            .map(x => {
                const t = (x.date_to.value ? moment(x.date_to.value) : moment.utc());
                const f = moment(x.date_from.value);
                return t.diff(f, 'days');
            })
            .filter(x => !isNaN(x));

        tenure.value = (days && days.length ? days.reduce((a, b) => a + b) : 0).toString();

        this.changeFormValue('tenure', tenure);
    }

    onVacationsRender({ type, elem }) {
        if (type === 'buttons') {
            return [...elem, (
                <button className={'btn btn-success btn-outline float-left mb-1'} onClick={this.togglePreviousVacations}>
                    <i
                        className="material-icons material-icons"
                        style={{
                            top: '2px',
                            position: 'relative',
                            fontSize: '13px',
                        }}
                    >list</i>
                    <span style={{ paddingLeft: '3px' }}>{!this.state.showPrevVacations ? 'Show' : 'Hide'} previous years</span>
                </button>)
            ]
        }

        return elem;
    }

    togglePreviousVacations(e) {
        e.preventDefault();

        this.setState({ showPrevVacations: !this.state.showPrevVacations });
    }

    onRenderVacationItem({ item, factory }) {
        if (!this.state.showPrevVacations) {
            if (item.date_from.value) {
                const f = moment(item.date_from.value);
                const now = moment(moment.now()).utc(false);

                if (f.year() !== now.year()) {
                    return null;
                }
            }
        }
        return factory(item);
    }
}

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToProps = (dispatch) => {
    return {
        getEmployee: (id) => {
            fetchEmployee(id)(dispatch);
        },
        saveForm: (id, data) => {
            if (id) {
                updateEmployee(id, data)(dispatch);
            } else {
                addEmployee(data)(dispatch);
            }
        },
        goToEmployees: () => {
            dispatch(push('/pages/employees'));
        },
        goToLogs: (id) => {
            dispatch(push(`/pages/employee/${id}/logs`));
        },
        getCountries: () => {
            fetchCountries()(dispatch);
        },
        getStates: countryId => {
            fetchStates(countryId)(dispatch);
        },
        notifyValidationFailed: (id) => {
            dispatch(notify({
                title: id ? 'Update Employee' : 'Add New Employee',
                message: id ? 'Failed to update employee. Please review errors below' : 'Failed to add employee. Please review errors below',
                status: 'error',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
            }));
        },
        goToAttachments: (id) => {
            dispatch(push('/pages/employee/attach/' + id));
        },
        getPdf: (id) => {
            getEmployeePdf(id)(dispatch);
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(ManageEmployeeItem);



// WEBPACK FOOTER //
// ./src/containers/Employee/index.js